import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import Paper from 'material-ui/Paper';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import style from '../../styles/styles';
import { getTrails } from '../../store/trails/actions';
import { getTypes } from '../../store/types/actions';
import { fetchApp } from '../../store/apps/actions';
import { getCustomFields } from '../../store/customfields/actions';
import {
    fetchRoadBookConfiguration,
    getRoadBookConfigurations,
    putRoadBookConfigurations,
} from '../../store/roadBookConfigurations/actions';
import withTranslation from '../../hoc/withTranslation';
import styles from '../page/PagePage.css';
import RoadBookConfigurationForm from '../../components/roadbook/RoadBookConfigurationForm';
import { ROAD_BOOK_CONFIGURATION_PAGE, ROAD_BOOKS_PAGE } from '../../constants/routes';
import AdminService, { SUPER_ADMIN } from '../../services/admin';

export class EditRoadBookConfigurationPage extends React.Component {
    static propTypes = {
        app: PropTypes.object,
    };

    state = {
        name: null,
    };

    componentWillMount() {
        this.fetchApplication();
        this.fetchRoadBookConfiguration();
        if (this.props.app && !this.props.trailsPending && this.props.trails[this.props.currentLang].length === 0) {
            this.props.getTrails(this.props.app, this.props.currentLang);
        }
        if (this.props.app && !this.props.typesPending && this.props.types.length === 0) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
        }
        if (this.props.app && !this.props.customFieldsPending && !this.props.customFields) {
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (
            nextProps.app
            && !this.props.trailsPending
            && !nextProps.trailsPending
            && this.props.trails[nextProps.currentLang].length === 0
        ) {
            nextProps.getTrails(nextProps.app, nextProps.currentLang);
        }
        if (
            nextProps.app
            && !this.props.typesPending
            && !nextProps.typesPending
            && this.props.types.length === 0
        ) {
            nextProps.getTypes(nextProps.app.id, nextProps.currentLang);
        }
        if (
            nextProps.app
            && !this.props.customFieldsPending
            && !nextProps.customFieldsPending
            && !this.props.customFields
        ) {
            nextProps.getCustomFields(nextProps.app.id);
        }
        if (this.props.sending && !nextProps.sending) {
            if (nextProps.currentRoadBookConfiguration) {
                nextProps.history.push(
                    ROAD_BOOK_CONFIGURATION_PAGE.replace(':appId', nextProps.app.id)
                        .replace(':roadBookConfigurationId', nextProps.currentRoadBookConfiguration.id),
                );
            } else {
                nextProps.history.push(ROAD_BOOKS_PAGE.replace(':appId', nextProps.app.id));
            }
        }
    }

    handleFormSubmit = async (formProps) => {
        await this.props.putRoadBookConfigurations(this.props.app.id, formProps, this.props.currentLang);
    };

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    fetchRoadBookConfiguration(appId = null, roadBookConfigurationId = null) {
        if (this.props.match && !this.props.roadBookConfigurationsPending) {
            const app = appId || this.props.match.params.appId;
            const roadBookConfiguration = roadBookConfigurationId
                || this.props.match.params.roadBookConfigurationId;
            if (app && roadBookConfiguration) {
                const withDisabled = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);
                this.props.fetchRoadBookConfiguration(app,
                    roadBookConfiguration,
                    this.props.currentLang,
                    withDisabled,
                );
            }
        }
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    <h3 style={style.navigation}>
                        {this.props.t(
                            'module.road_book.road_book_configuration_add',
                            { name: this.props.app.name },
                        )}
                    </h3>

                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.road_book.new_road_book_configuration')}
                                </Subheader>
                                <div style={style.paper}>
                                    <RoadBookConfigurationForm
                                        app={this.props.app}
                                        types={this.props.types}
                                        trails={this.props.trails[this.props.currentLang]}
                                        customFields={this.props.customFields}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.submitting}
                                        initialValues={this.props.currentRoadBookConfiguration}
                                    />
                                </div>
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        loading: state.apps.pending
            || state.roadBookConfigurations.pending
            || state.trails.pending
            || state.types.pending
            || state.customFields.pending,
        appsPending: state.apps.pending,
        roadBookConfigurationsPending: state.roadBookConfigurations.pending,
        trailsPending: state.trails.pending,
        typesPending: state.types.pending,
        customFieldsPending: state.customFields.pending,
        error: state.apps.error
            || state.roadBookConfigurations.error
            || state.trails.error
            || state.types.error
            || state.customFields.error,
        user: state.auth.content,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.roadBookConfigurations.sending,
        currentRoadBookConfiguration: state.roadBookConfigurations.currentRoadBookConfiguration,
        trails: state.trails.content,
        types: state.types.content,
        customFields: state.customFields.content,
    };
}

export default connect(mapStateToProps, {
    getTrails,
    getTypes,
    fetchApp,
    getCustomFields,
    getRoadBookConfigurations,
    putRoadBookConfigurations,
    fetchRoadBookConfiguration,
})(withRouter(withTranslation(EditRoadBookConfigurationPage)));



// WEBPACK FOOTER //
// src/containers/roadbook/EditRoadBookAvailablePage.js